<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Payment Status
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CRow class="mb-5">
        <CCol class="col-xl-12 p-1">
          <CCard class="custom-form-card ml-2 mr-2">
            <CCardBody>
              <CRow>
                <CCol class="col-12">
                  <b-table striped hover show-empty
                    :items="table.items"
                    :fields="table.fields"
                    :busy="!table.isLoaded"
                    no-local-sorting no-sort-reset
                  >
                    <template #cell(no)="row">
                      {{ row.index+1 }}.
                    </template>
                    <template #cell(code)="row">
                      {{ $helper.showData(row.item.code, "string") }}
                    </template>
                    <template #cell(action)="row">
                      <b-button variant="danger" size="sm" title="Remove Row" @click="promptRemoveItem(row.item.code)"><CIcon name="cil-minus"/></b-button>
                    </template>
                    <template #head(action)>
                      <b-button variant="primary" size="sm" title="Add New Row" @click="promptAddItem"><CIcon name="cil-plus"/></b-button>
                    </template>
                    <template slot="empty">
                      <div v-if="!table.isLoaded" class="text-center">
                        <b-spinner label="Fetching Data..."></b-spinner>
                      </div> 
                      <div v-else class="text-center">
                        Tidak ada data
                      </div> 
                    </template>
                  </b-table>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @limit-change="onTableLimitChange" @page-change="onTablePageChange" />
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CForm>
    <b-modal
      v-model="addModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Kode Status:"
              label-for="modal-add-item"
              :state="addModalData.code.isValid"
            >
              <b-form-input
                v-model="addModalData.code.value"
                :state="addModalData.code.isValid"
                placeholder="Kode Status"
                id="modal-add-item"
                maxlength="2"
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="addModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="addModalData.isSubmitting" @click="addItem">
              <b-spinner small v-if="addModalData.isSubmitting" />
              <span v-else>Add</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
    <b-modal
      v-model="removeModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CRow>
        <CCol class="col-12">
          <p>Apakah anda yakin ingin menghapus Kode Payment Status ini?</p>
        </CCol>
      </CRow>
      <CRow class="mt-1 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="removeModalData.isShowing = false">Cancel</b-btn>
          <b-btn variant="danger" type="button" style="width:5rem" :disabled="removeModalData.isSubmitting" @click="removeItem">
            <b-spinner small v-if="removeModalData.isSubmitting" />
            <span v-else>Remove</span>
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'ConfigPaymentStatus',
  data() {
    return {
      isSubmitting: false,
      
      table: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          { key: "no", label: "No.", sortable: false },
          { key: "code", label: "Kode Status", sortable: false },
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-button" }
        ],
        items: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      addModalData: {
        isShowing: false,
        isSubmitting: false,
        code: {
          value: '',
          isValid: null
        }
      },
      removeModalData: {
        isShowing: false,
        isSubmitting: false,
        code: ''
      }
    }
  },
  methods: {
    // update table with server-side processing on change
    onTableLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      this.getNotaryTableItems()
    },
    onTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getTableItems(newPage)
    },
    // get paginated table contents from server-side
    getTableItems(page = 1) {
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/fiducia/paymentStatus/getAll"
      let params = {}
      params['page'] = (this.table.currentPage - 1)
      params['size'] = this.table.perPage
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.table.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.table.items = response.data.data.data
            this.table.totalRows = response.data.data.totalElements
            this.table.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Status Payment Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Status Payment Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Status Payment Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    addItem(event) {
      event.preventDefault()
      let data = new FormData()
      data.set('code', this.addModalData.code.value)
      let postUrl = '/fiducia/paymentStatus/add'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.addModalData.isSubmitting = true
        this.$axios.post(postUrl, data).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Create Payment Status Berhasil!")
            this.addModalData.isShowing = false
            this.getTableItems()
          }
          else{
            this.$helper.toastError(this, "Create Payment Status Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Create Payment Status Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Create Payment Status Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.addModalData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    removeItem() {
      let data = new FormData()
      data.set('code', this.removeModalData.code)
      let postUrl = '/fiducia/paymentStatus/delete'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.removeModalData.isSubmitting = true
        this.$axios.post(postUrl, data).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Delete Payment Status Berhasil!")
            this.removeModalData.isShowing = false
            this.getTableItems()
          }
          else{
            this.$helper.toastError(this, "Delete Payment Status Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Delete Payment Status Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Delete Payment Status Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.removeModalData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    promptAddItem() {
      this.addModalData.code.value = ''
      this.addModalData.isShowing = true
    },
    promptRemoveItem(code) {
      this.removeModalData.code = code
      this.removeModalData.isShowing = true
    },
    saveTable(event) {
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = ''
        // // if editing
        // if(!this.$helper.isEmpty(this.mouId)){
        //   obj["mouId"] = this.mouId
        //   obj["notaryId"] = this.$route.params.notarisId
        //   postUrl = '/mou/edit'
        // }
        // // if adding
        // else{
        //   obj["status"] = "NA"
        //   obj["notaryId"] = this.$route.params.notarisId
        //   postUrl = '/mou/add'
        // }

        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          // this.$axios.post(postUrl, obj).then(response => {
          //   if(response.status == 200){
          //     // this.$helper.toastSuccess(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Berhasil! Mohon melakukan Aktivasi MoU terlebih dahulu melalui tabel Data Mou." : "Edit MoU Berhasil!"))

          //     this.$store.commit('set', ['toast', true])
          //     this.$store.commit('set', ['toastMsg', "Edit MOU Berhasil! " + (response.data.reason ? response.data.reason : "")])
          //     this.$router.push({ name: 'Notaris Edit', params: { notarisId: this.$route.params.notarisId }  });
          //   }
          //   else{
          //     this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          //   }
          // })
          // .catch(error => {
          //   if(!this.$helper.isEmpty(error.response)){
          //     this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          //   }
          //   else{
          //     this.$helper.toastError(this, (this.$helper.isEmpty(this.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          //   }
          // })
          // .finally(() => {
          //   this.isSubmitting = false
          // })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    }
  },
  computed: {
  },
  async mounted() {
    this.getTableItems()
  },
  created(){
  }
}
</script>

<style>

</style>
